<template>
	<div>
		<v-tabs 
			class="round-card"
			height="34"
			background-color="background-1"
			slider-color="primary">
			<v-tab key="Campi" ripple class="secondary-tab">
				Campi
			</v-tab>
			<v-tab key="Azioni" ripple class="secondary-tab">
				Azioni
			</v-tab>
			<v-tab key="Template" ripple class="secondary-tab">
				Tipi
			</v-tab>
			<v-tab key="Altro" ripple class="secondary-tab">
				Altro
			</v-tab>

			<v-tab-item class="background-1 pt-3 pb-1" key="Campi">
				<v-row class="ma-0">
					
					<v-col class="pa-0 pt-2" cols="12">
						<fields-selector model-def="subscription"></fields-selector>
					</v-col>

				</v-row>
			</v-tab-item>
			
			<v-tab-item class="background-1 pt-3 pb-1" key="Azioni">
				<v-row class="ma-0">
					
					<v-col class="pa-0 pt-2" cols="12">
						<actions-selector model-def="subscription"></actions-selector>
					</v-col>

				</v-row>
			</v-tab-item>

			<v-tab-item class="background-1 pt-3 pb-1" key="Tipi">
				<v-row class="ma-0">
					<v-col class="pa-0" cols="12">
						<crud
							title="Tipo abbonamenti"
							action-icon='settings'
							model-def='generaltypes-subscription_type'
							action-position='absolute'
							crudDialog
						></crud>
					</v-col>
				</v-row>
			</v-tab-item>
			
			<v-tab-item class="background-1 pt-3 pb-1" key="Template">
				<v-row class="ma-0">
					<subscriptions-options></subscriptions-options>
				</v-row>
			</v-tab-item>

		</v-tabs>
		
		<v-tabs 
			class="tabs-pill mt-4"
			height="34"
			background-color="background-1"
			slider-color="primary">
			<v-tab key="Campi" ripple class="secondary-tab">
				Campi
			</v-tab>


			<v-tab-item class="background-1 pt-3" key="Campi">
				<v-row class="ma-0 pb-offset">
					
					<v-col class="pa-0 pt-2" cols="12">
						<fields-selector model-def="productsubscription" audit></fields-selector>
					</v-col>

				</v-row>
			</v-tab-item>
		</v-tabs>
	</div>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'
import SubscriptionsOptions from '@/components/modules/subscriptions/settings/SubscriptionsOptions'

	export default {
		name:'subscriptions-settings',
        components: {
			FieldsSelector,
			ActionsSelector,
            SubscriptionsOptions
        },		
		data() {
			return {

			}
		},
	}
  </script>
